@if (video) {
  <div class="video_splash d-flex justify-content-between">
    <div class="d-flex">
      <img *inView [src]="video.thumb" alt="thumbnail" aria-label="thumbnail" />
      <div>
        <span>{{ video.title }}</span>
        <br />
        @if (replies && replies.length) {
          <span>{{ "com.latest_comment" | translate }}: {{ replies[0].created.toDate() | date: "MMM Do" : true }}</span>
        }
      </div>
    </div>
    <button (click)="showVideo(video)" class="btn btn-primary" aria-label="view video">{{ "com.view_video" | translate }}</button>
  </div>
}
<div
  class="card"
  [class.scheduled]="comment.scheduled_date"
  [class]="isCommunityPost ? 'community-post' : 'comment-container'"
  [class.employee-only]="comment.employee_only"
  [class.queued]="queued"
  [class.force-dark]="forceDark"
  [class.flagged]="user && user?.is_sphere_admin && comment.flags && comment.flags.length && !comment.cleared"
  [id]="comment.id"
>
  @if (user?.is_sphere_admin && comment.flags && comment.flags.length && !comment.cleared) {
    <div class="flag-warning bold">
      {{ comment.flags.length + " Flag" + (comment.flags.length > 1 ? "s" : "") + "!" }}
    </div>
  }
  @if (isCommunityPost) {
    <div class="message-header">
      <!-- @if (comment.pinned && betaStringId) {
        <div class="pinned-indicator m-b-10 m-l-40">
          <fa-icon icon="thumbtack" class="c-primary m-r-5"></fa-icon>
          <span class="t-12 bold text-muted">PINNED POST</span>
        </div>
      } -->
      <ul class="list-inline d-flex align-items-center m-l-40">
        <li class="list-inline-item mr-0">
          <a href="javascript:void(0)" [routerLink]="['/profile', comment.author.id]" class="profile-photo-container">
            <img
              [src]="
                comment.author.id == user?.id
                  ? user?.photoURL
                    ? userService.profilePicture
                    : './assets/images/default_avatar.jpg'
                  : comment.author.photo
                    ? comment.author.photo
                    : './assets/images/default_avatar.jpg'
              "
              class="profile-photo"
              [alt]="comment.author.name + ' profile photo'"
            />
            <span class="sr-only">{{ comment.author.name }} profile</span>
          </a>
        </li>
        <li class="list-inline-item m-r-5">
          <a href="javascript:void(0)" class="text-decoration-none" [routerLink]="['/profile', comment.author.id]">
            <fui-heading [text]="comment.author.name" [level]="2" fontSize="f6" extraClasses="t-18 bold author-name"></fui-heading>
          </a>
          <span class="sr-only">{{ comment.author.name }} profile</span>
        </li>
        @if (comment.sphere_only && user?.is_sphere_admin) {
          <li class="list-inline-item m-r-5" placement="top" [ngbTooltip]="'Only shows in ' + env.studioOnePlusBrandName">
            <img src="./assets/icons/plus-icon-blue.png" style="width: 15px; height: 15px" alt="only shows in studio one pro+" />
          </li>
        }
        @if (userService.badgeUsersMap?.community_moderators && userService.badgeUsersMap?.community_moderators[comment.author.id]) {
          <li class="list-inline-item m-r-5">
            <div ngbTooltip="Community Moderator" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
              <fa-icon icon="star" class="community-wizard-badge t-18" aria-hidden="true"></fa-icon>
              <span class="sr-only">community moderator</span>
            </div>
          </li>
        }
        @if (userService.badgeUsersMap && userService.badgeUsersMap.employees && userService.badgeUsersMap.employees[comment.author.id]) {
          <li class="list-inline-item m-r-5">
            <div ngbTooltip="PreSonus Employee" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
              <img
                [src]="userService.themeImg == 'plainlight' ? './assets/icons/presonus-badge-blue.svg' : './assets/icons/presonus-badge-white.svg'"
                class="community-employee-badge"
                alt="presonus employee"
                aria-hidden="true"
              />
              <span class="sr-only">presonus employee</span>
            </div>
          </li>
        }
        @if (userService.badgeUsersMap?.experts && userService.badgeUsersMap?.experts[comment.author.id]) {
          <li class="list-inline-item m-r-5">
            <div ngbTooltip="Studio One Expert" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
              <fa-icon icon="graduation-cap" class="community-employee-badge" aria-hidden="true"></fa-icon>
              <span class="sr-only">studio one expert</span>
            </div>
          </li>
        }
        <li class="list-inline-item fui-eyebrow m-r-5">
          <span class="time-created" (click)="detailClick()" aria-label="posted on">
            {{ (queued ? comment.created : comment.created.toDate()) | date: "MMM Do [at] h:mma" : true }}
          </span>
        </li>
      </ul>
      <ul class="list-inline channels m-r-5">
        @if (comment.employee_only) {
          <li class="list-inline-item" ngbTooltip="Only PreSonus/Fender employees can see this post.">
            <span class="channel blue">Employee Only</span>
          </li>
        }
        @if ((!comment.channels || !comment.channels.length) && (!comment.topics || !comment.topics.length)) {
          <li class="list-inline-item m-r-5">
            <a href="javascript:void(0)" class="channel" (click)="channelSelected.next('general')" aria-label="general" tabindex="0">
              {{ "com.skills.general" | translate }}
            </a>
            <span class="sr-only">go to {{ "com.skills.general" | translate }}</span>
          </li>
        }
        @if (comment.topics && comment.topics.length && displayedSection != "topics") {
          <li class="list-inline-item m-r-5">
            <span class="topic" (click)="topicSelected.next(comment.topics[0])">
              <span class="t-10">From</span>
              &nbsp;
              <strong>{{ communityService.topicMap[comment.topics[0]].title }}</strong>
            </span>
          </li>
        }
        @if (comment.channels && !betaStringId) {
          @for (channel of comment.channels; track channel) {
            <li class="list-inline-item">
              @if (communityService.skillsMap[channel] || communityService.extraChannelsMap[channel]) {
                <a
                  class="channel"
                  [class.disabled]="communityService.extraChannelsMap[channel] && !communityService.extraChannelsMap[channel].active"
                  (click)="selectChannel(channel)"
                  tabindex="0"
                  href="javascript:void(0)"
                >
                  #
                  {{
                    communityService.skillsMap[channel]
                      ? ("com.skills." + communityService.skillsMap[channel].string_id | translate)
                      : ("com.skills." + communityService.extraChannelsMap[channel].string_id | translate)
                  }}
                  <span class="sr-only">Go to channel</span>
                </a>
              }
            </li>
          }
        }
        @if (comment.channels && betaStringId) {
          @for (channel of comment.channels; track channel) {
            @if (betaService.communityTagMap[channel] && !betaManagerEditingChannels) {
              <li class="list-inline-item">
                <a href="javascript:void(0)" class="channel" (click)="selectChannel(channel)" tabindex="0"># {{ betaService.communityTagMap[channel].title }}</a>
              </li>
            }
          }
          @if (betaStringId && !betaManagerEditingChannels && isBetaManager) {
            <li class="t-12 list-inline-item">
              <button class="small-btn" (click)="betaManagerEditingChannels = true"><fa-icon icon="pencil"></fa-icon></button>
            </li>
          }
          @if (betaManagerEditingChannels) {
            <li class="list-inline-item position-relative">
              @for (channel of comment.channels; track channel) {
                @if (betaService.communityTagMap[channel]) {
                  <span class="create-post-selected-channel">
                    # {{ betaService.communityTagMap[channel].title }}
                    <button class="m-l-5 fa-button" (click)="removeChannel(channel)">
                      <fa-icon icon="times-circle"></fa-icon>
                    </button>
                  </span>
                }
              }
              @if (!comment.channels || comment.channels.length < 3) {
                <button
                  class="add-channel-button c-lblue bold pointer"
                  aria-controls="channel-list"
                  [attr.aria-expanded]="shouldShowChannelSelector"
                  (click)="shouldShowChannelSelector = !shouldShowChannelSelector"
                >
                  {{ "com.add_channel" | translate }}
                  <fa-icon icon="plus-circle" class="c-lblue t-14"></fa-icon>
                </button>
              }
              @if (shouldShowChannelSelector) {
                <div class="channel-selector" id="channel-list">
                  <div class="channel-list overflow-auto h-100">
                    @for (tag of betaService.communityTags; track tag) {
                      <button class="channel-button bold pointer t-14 p-1" (click)="addChannel(tag)">
                        <fa-icon icon="hashtag" class="c-lblue"></fa-icon>
                        {{ tag.title }}
                      </button>
                    }
                  </div>
                </div>
              }
              <button class="small-btn" (click)="betaManagerEditingChannels = false">Done</button>
            </li>
          }
        }
      </ul>
    </div>
  }

  <div class="msg">
    @if (!isCommunityPost) {
      <div class="d-flex">
        <ul class="list-inline bold">
          <li class="list-inline-item">
            <img [src]="comment.author?.photo || './assets/images/default_avatar.jpg'" class="profile-photo" [alt]="comment.author.name + ' profile photo'" />
          </li>
          <li class="list-inline-item">
            <a href="javascript:void(0)" (click)="viewProfile(comment.author.id)" class="bold t-14 author-name" [class.force-dark]="forceDark">{{ comment.author.name }}&nbsp;</a>
          </li>
          @if (communityService.communityWizards[comment.author.id]) {
            <li class="list-inline-item">
              <div ngbTooltip="Community Moderator" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
                <fa-icon icon="star" class="community-wizard-badge t-18" aria-hidden="true"></fa-icon>
                <span class="sr-only">community moderator</span>
              </div>
            </li>
          }
          @if (userService.badgeUsersMap && userService.badgeUsersMap.employees && userService.badgeUsersMap.employees[comment.author.id]) {
            <li class="list-inline-item">
              <div ngbTooltip="PreSonus Employee" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
                <img
                  [src]="userService.themeImg == 'plainlight' ? './assets/icons/presonus-badge-blue.svg' : './assets/icons/presonus-badge-white.svg'"
                  class="community-employee-badge"
                  alt="presonus employee"
                  aria-hidden="true"
                />
                <span class="sr-only">presonus employee</span>
              </div>
            </li>
          }
          @if (userService.badgeUsersMap && userService.badgeUsersMap.experts && userService.badgeUsersMap.experts[comment.author.id]) {
            <li class="list-inline-item">
              <div ngbTooltip="Studio One Expert" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
                <fa-icon icon="graduation-cap" class="community-employee-badge" aria-hidden="true"></fa-icon>
                <span class="sr-only">studio one expert</span>
              </div>
            </li>
          }
          <li class="list-inline-item">
            <div class="timestamp">{{ comment.created.toDate() | date: "MMM Do [at] h:mma" : true }}</div>
          </li>
        </ul>
      </div>
    }
    @if (comment.subject) {
      <div class="main-post-subject" [innerHTML]="comment.subject"></div>
    }
    <p class="text main-post-text mb-0" [innerHTML]="comment.htmlMessage ? (comment.htmlMessage | safe: 'html') : comment.message"></p>
    @if (queued && comment.files?.length) {
      <div class="m-t-20 text-muted">
        {{ "com.attached_files" | translate: { count: comment.files.length } }}
        <br />
        <br />
        {{ "com.post_is_queued" | translate }}
      </div>
    }
    @if (queued && !comment.files?.length) {
      <div class="m-t-20 text-muted">
        <fa-icon icon="spinner" animation="spin"></fa-icon>
        Sending your post...
      </div>
    }

    <!-- START | comment has files -->
    @if (comment.files && comment.files.length && !queued) {
      <div class="post-attachments" [class.multiple]="comment.files.length > 1">
        @for (file of comment.files; track file) {
          <div class="attachment" [class.is-image]="workspaceService.imageFiles[file.extension]">
            @if (workspaceService.imageFiles[file.extension]) {
              <div *inView>
                <img [src]="communityService.buildFileUrl(file.user_id, file)" (click)="showImage(communityService.buildFileUrl(file.user_id, file))" class="image-border" alt="" />
                <div class="p-x-5">
                  <span class="t-12 font-weight-bold">{{ file.filename }}</span>
                </div>
              </div>
            }
            @if (workspaceService.audioFiles[file.extension]) {
              <div class="m-t-20">
                @if (communityService.displayAudioWaveforms) {
                  @if (comment.shouldLoadWaveform) {
                    <myp-waveform-comments
                      (audioPlayed)="audioPlayed($event)"
                      (audioPaused)="audioPaused($event)"
                      [showComments]="false"
                      #waveformComments
                      [isPostAttachment]="true"
                      [file]="file"
                    ></myp-waveform-comments>
                  }
                  @if (!comment.shouldLoadWaveform) {
                    <div style="height: 150px; background-color: rgba(0, 0, 0, 0.6)" class="d-flex align-items-center justify-content-center">
                      <div class="text-center">
                        <a href="javascript:void(0)" class="btn btn-primary" (click)="comment.shouldLoadWaveform = true">{{ "com.load_waveform" | translate }}</a>
                        <br />
                        <span>{{ file.filesize | bytesToSize }}</span>
                      </div>
                    </div>
                  }
                }
                @if (!communityService.displayAudioWaveforms) {
                  <div class="post-audio-play" [class.pulse-blue]="communityService.playingAudioFile && communityService.playingAudioFile.id == file.id" (click)="playAudio(file, comment.id, $event)">
                    <!-- <canvas [id]="comment.id + '_visualizer'" style="position: absolute; width: 100%; height: 100%;"></canvas> -->
                    <fa-icon [icon]="communityService.playingAudioFile && communityService.playingAudioFile.id == file.id ? 'stop-circle' : 'play-circle'" class="t-40"></fa-icon>
                    <div class="m-l-10 flex-column align-items-left">
                      <fui-heading [text]="file.filename" [level]="3" fontSize="f7" extraClasses="t-20 bold d-block"></fui-heading>
                      <p class="text-muted t-16 mb-0">{{ file.filesize | bytesToSize }}</p>
                    </div>
                  </div>
                }
              </div>
            }
            @if (workspaceService.videoFiles[file.extension]) {
              <div *inView>
                <video width="100%" [src]="file.url" controls></video>
              </div>
            }
            @if (!workspaceService.imageFiles[file.extension] && !workspaceService.audioFiles[file.extension] && !workspaceService.videoFiles[file.extension]) {
              <div role="button" class="generic-file-attachment pointer" (click)="downloadFile(file)">
                {{ file.filename }}
                <fa-icon icon="download" aria-hidden="true"></fa-icon>
                <span class="sr-only">download</span>
              </div>
            }
          </div>
        }
      </div>
    }
    <!-- END | comment has files -->

    <!-- START | comment has learn content -->
    @if (comment.learn_content && comment.learn_content.length && !queued) {
      <div class="post-attachments m-y-20 grid-container pad-10">
        @for (item of comment.learn_content; track item) {
          @if (item.content.type == "video") {
            <myp-video-grid-item [video]="item.content"></myp-video-grid-item>
          }
          @if (item.content.type == "course" || item.content.type == "lesson") {
            <myp-learn-list-item [item]="item.content"></myp-learn-list-item>
          }
        }
      </div>
    }
    <!-- END | comment has learn content -->

    <!-- START | comment has embeds -->
    @if (comment.embeds && comment.embeds.length && !queued) {
      <div class="post-attachments">
        @for (embed of comment.embeds; track embed) {
          <div class="message-embed message-embed--{{ embed.type }} message-embed--{{ embed.subtype }}">
            <iframe width="560" height="315" [src]="embed.src" frameborder="0" allowfullscreen></iframe>
          </div>
        }
      </div>
    }
    <!-- END | comment has embed -->

    <!-- START | comment has articles -->
    @if (comment.articles && comment.articles.length && !queued) {
      <ul class="post-attachments" role="group" aria-label="articles">
        @for (item of comment.articles; track item) {
          <li style="list-style-type: none">
            <button type="button" class="comment-article-attachment bg-transparent" (click)="showArticle(item)">
              <fa-icon icon="newspaper" class="icon" aria-hidden="true"></fa-icon>
              <div class="d-flex flex-column text-left">
                <fui-heading [text]="item.article.name" [level]="4" fontSize="f7" extraClasses="bold"></fui-heading>
                <span class="t-12 text-muted" aria-label="article created at">{{ item.article.created_at_pretty }}</span>
                <div class="block text-right">
                  <span class="link bold">
                    Read Article
                    <fa-icon icon="chevron-right" aria-hidden="true"></fa-icon>
                  </span>
                </div>
              </div>
            </button>
          </li>
        }
      </ul>
    }
    <!-- END | comment has articles -->

    <!-- START | comment has public file links -->
    @if (comment.public_file_links && comment.public_file_links.length && !queued) {
      <ul class="post-attachments" role="group" aria-label="links">
        @for (item of comment.public_file_links; track item) {
          <li style="list-style-type: none">
            <button type="button" class="comment-article-attachment bg-transparent" (click)="goToPublicFile(item)">
              <fa-icon [icon]="workspaceService.audioFiles[item.publicFile.extension] ? 'play-circle' : 'file'" class="icon" aria-hidden="true"></fa-icon>
              <div class="d-flex flex-column text-left">
                <fui-heading [text]="item.publicFile.filename" [level]="4" fontSize="f7" extraClasses="bold"></fui-heading>
                <span class="t-12 text-muted" aria-label="article created at">{{ item.publicFile.description }}</span>
                <div class="block text-right">
                  <span class="link bold">
                    View & Comment
                    <fa-icon icon="chevron-right" aria-hidden="true"></fa-icon>
                  </span>
                </div>
              </div>
            </button>
          </li>
        }
      </ul>
    }
    <!-- END | comment has public file links -->

    @if (isBetaManager && comment.pinned) {
      <div>
        <button class="brand-btn-reverse sm" (click)="deletePinnedPost()">Delete Pinned Post</button>
        &nbsp;
        <button class="brand-btn-reverse sm" (click)="editPost(comment, true)">Edit Pinned Post</button>
        &nbsp;
        <button class="brand-btn-reverse sm" (click)="unpinBetaPost()">Unpin Post</button>
      </div>
    }

    @if (!queued && !comment.pinned) {
      <div class="timestamp justify-content-between">
        <ul class="list-inline mb-0">
          @if (!communityService.profile || !communityService.profile.status || communityService.profile.status == "active") {
            @if (comment.edited) {
              <li class="list-inline-item">
                <span class="edited-message">{{ "com.edited" | translate }}</span>
              </li>
            }
            <li class="list-inline-item">
              <button
                type="button"
                class="btn btn-transparent p-1"
                (keyup.enter)="like(comment)"
                (focus)="likeBubbleMouseLeaveByFocus(0, 1)"
                (click)="like(comment)"
                [attr.aria-pressed]="comment.iLike || (comment.likes && comment.likes.includes(this.userService.user?.id))"
                aria-label="like"
                [ngbTooltip]="'com.like_this_comment' | translate"
                placement="right"
              >
                <fa-icon class="msg-options-link" [class.i-liked]="comment.iLike || (comment.likes && comment.likes.includes(this.userService.user?.id))" icon="thumbs-up" aria-hidden="true"></fa-icon>
                <span class="sr-only">like</span>
              </button>
            </li>
            @if (comment.likes && comment.likes.length) {
              <li class="list-inline-item position-relative">
                <div
                  class="like-count"
                  (click)="likeMouseEnter(comment)"
                  (keyup.enter)="likeMouseEnter(comment)"
                  (keyup.space)="likeMouseEnter(comment)"
                  (mouseenter)="likeMouseEnter(comment)"
                  (mouseleave)="likeMouseLeave(comment)"
                  role="button"
                  tabindex="0"
                  [attr.aria-expanded]="!!shouldShowLikesList"
                  aria-controls="like-bubble-container"
                >
                  {{ comment.likes.length }}
                </div>
                <span class="sr-only">Number of likes {{ comment.likes.length }}</span>
                @if (shouldShowLikesList == comment.id) {
                  <div class="like-bubble-container" id="like-bubble-container">
                    @if (activeHoveringLikeUserName) {
                      <div style="position: absolute; top: -30px; background-color: rgba(0, 0, 0, 0.8); border-radius: 10px; padding: 10px">
                        <span class="c-white">{{ activeHoveringLikeUserName }}</span>
                      </div>
                    }
                    <ul class="like-bubble-background" (mouseenter)="likesContainerEnter(comment)" (mouseleave)="likesContainerLeave(comment)">
                      @for (id of comment.likes; track id; let idx = $index) {
                        <li
                          (mouseenter)="likeBubbleMouseEnter(id)"
                          (mouseleave)="likeBubbleMouseLeave(id)"
                          (focus)="likeBubbleMouseEnter(id)"
                          (focusout)="likeBubbleMouseLeaveByFocus(idx, comment.likes.length)"
                          (click)="viewProfile(id)"
                          class="like-bubble"
                          [id]="'user_' + id"
                          [ngStyle]="{
                            'background-image':
                              'url(' + (communityService.cachedPhotos[id] ? communityService.cachedPhotos[id] : 'https://s3.amazonaws.com/mypresonus/profile/' + id + '-profile-photo.png') + ')',
                          }"
                          role="link"
                          tabindex="0"
                        >
                          <span class="sr-only">go to {{ activeHoveringLikeUserNameList[id] ?? "user" }} profile</span>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </li>
            }
            @if (!reviewing && isCommunityPost && !betaStringId) {
              <li class="list-inline-item">
                <button
                  type="button"
                  class="btn btn-transparent p-1"
                  (keyup.enter)="pinPost(comment)"
                  (click)="pinPost(comment)"
                  [attr.aria-pressed]="comment.pins && comment.pins.includes(userService.user?.id)"
                  aria-label="pin post"
                  [ngbTooltip]="'Pin Post'"
                >
                  <fa-icon class="msg-options-link" [class.active]="comment.pins && comment.pins.includes(userService.user?.id)" icon="thumbtack" aria-hidden="true"></fa-icon>
                  <span class="sr-only">pin post</span>
                </button>
              </li>
            }
            @if (!reviewing) {
              <li class="list-inline-item">
                <button
                  type="button"
                  class="btn btn-transparent p-1"
                  [ngbTooltip]="'sphere.options' | translate"
                  (keyup.enter)="msgOptions(comment)"
                  (click)="msgOptions(comment)"
                  aria-label="options"
                >
                  <fa-icon class="msg-options-link" icon="ellipsis-h" aria-hidden="true"></fa-icon>
                  <span class="sr-only">options</span>
                </button>
              </li>
            }
            @if (!reviewing) {
              <li class="list-inline-item" [ngbTooltip]="'com.reply' | translate" placement="right">
                <button
                  type="button"
                  class="btn btn-transparent p-1"
                  (keyup.enter)="toggleReplyUI(comment)"
                  (click)="toggleReplyUI(comment)"
                  aria-label="reply"
                  [attr.aria-expanded]="comment.replying"
                  [attr.aria-controls]="comment.key + '_reply_input_container'"
                  [ngbTooltip]="'com.reply' | translate"
                  placement="right"
                >
                  <fa-icon class="msg-options-link" icon="reply" aria-hidden="true"></fa-icon>
                  <span class="sr-only">reply</span>
                </button>
              </li>
            }
            @if (comment.scheduled_date) {
              <li class="list-inline-item">
                <fa-icon icon="clock" class="c-official-blue"></fa-icon>
                Scheduled for {{ comment.scheduled_date.toDate() | date: "MMM Do" }} at {{ comment.scheduled_date.toDate() | date: "h:mma" }}
              </li>
            }
          }
        </ul>
        @if (betaStringId) {
          <div>
            <button class="brand-btn-reverse sm m-r-5" (click)="copyLink(comment)">
              Copy Link&nbsp;
              <fa-icon icon="copy"></fa-icon>
            </button>
            @if (!isPostDetail) {
              <button class="brand-btn-reverse sm" (click)="detailClick()">
                View Post&nbsp;
                <fa-icon icon="chevron-right"></fa-icon>
              </button>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- START | replies -->
  @if (replies && replies.length && !queued) {
    <div class="d-block replies m-t-10 m-l-10" [class.w-full]="!isCommunityPost">
      @if (replies.length > 2 && !showingAllReplies) {
        <button type="button" class="btn btn-transparent p-1" (click)="showingAllReplies = !showingAllReplies" [ngbTooltip]="'Show ' + replies.length + ' Replies'" aria-label="show replies">
          <fa-icon icon="ellipsis-h" class="dot-link m-0" aria-hidden="true"></fa-icon>
          <span class="sr-only">show replies</span>
        </button>
      }
      @if (replies.length > 2) {
        <button class="msg-options-link text" (click)="showingAllReplies = !showingAllReplies">
          {{ showingAllReplies ? ("com.collapse_replies" | translate) : ("com.show_replies" | translate: { count: replies.length }) }}
        </button>
      }
      <ul class="list-group replies-list mb-0" role="group" aria-label="reply">
        @for (reply of replies; track reply; let i = $index) {
          @if (showingAllReplies ? true : i == replies.length - 1 || i == replies.length - 2) {
            <li class="list-group-item border-0 bg-transparent p-0">
              <div class="reply-container" [id]="reply.id" [class.force-dark]="forceDark" [class.flagged]="user && user?.is_sphere_admin && reply.flags && !reply.cleared" aria-label="reply">
                @if (reply.flags && !reply.cleared) {
                  <div class="flag-warning bold">{{ reply.flags.length + " Flag" + (reply.flags.length > 1 ? "s" : "") + "!" }}</div>
                }
                <div class="msg">
                  <ul class="list-inline bold timestamp">
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" [routerLink]="['/profile', reply.author.id]" class="profile-photo">
                        <img
                          [src]="
                            reply.author.photo
                              ? reply.author.photo + (reply.author.id == user?.id && userService.profilePhotoCacheBuster ? '?' + userService.profilePhotoCacheBuster : '')
                              : './assets/images/default_avatar.jpg'
                          "
                          class="profile-photo"
                          [alt]="reply.author.name + ' profile photo'"
                        />
                        <span class="sr-only">{{ reply.author.name }} profile</span>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" (click)="viewProfile(reply.author.id)" class="bold t-14 author-name" [class.force-dark]="forceDark">
                        {{ reply.author.name }}
                      </a>
                    </li>
                    @if (communityService.communityWizards[reply.author.id]) {
                      <li class="list-inline-item">
                        <div ngbTooltip="Community Moderator" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
                          <fa-icon icon="star" class="community-wizard-badge t-14" aria-hidden="true"></fa-icon>
                          <span class="sr-only">community moderator</span>
                        </div>
                      </li>
                    }
                    @if (userService.badgeUsersMap && userService.badgeUsersMap.employees && userService.badgeUsersMap.employees[reply.author.id]) {
                      <li class="list-inline-item">
                        <div ngbTooltip="PreSonus Employee" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
                          <img
                            [src]="userService.themeImg == 'plainlight' ? './assets/icons/presonus-badge-blue.svg' : './assets/icons/presonus-badge-white.svg'"
                            class="community-employee-badge"
                            alt="presonus employee"
                            aria-hidden="true"
                          />
                          <span class="sr-only">presonus employee</span>
                        </div>
                      </li>
                    }
                    @if (userService.badgeUsersMap && userService.badgeUsersMap.experts && userService.badgeUsersMap.experts[reply.author.id]) {
                      <li class="list-inline-item">
                        <div ngbTooltip="Studio One Expert" [triggers]="isMobileScreen() ? 'manual' : 'hover focus'" tabindex="0" [role]="isMobileScreen() ? 'button' : null">
                          <fa-icon icon="graduation-cap" class="community-employee-badge t-14" aria-hidden="true"></fa-icon>
                          <span class="sr-only">studio one expert</span>
                        </div>
                      </li>
                    }
                    <li class="list-inline-item">
                      <span class="sr-only">posted on</span>
                      {{ reply.created.toDate() | date: "MMM Do [at] h:mma" : true }}
                    </li>
                  </ul>
                  @if (reply.message) {
                    <p class="text mb-0 w-full" [innerHTML]="reply.htmlMessage ? (reply.htmlMessage | safe: 'html') : reply.message"></p>
                  }
                  @if (reply.files && reply.files.length && !queued) {
                    <div class="post-attachments" [class.multiple]="reply.files.length > 1">
                      @for (file of reply.files; track file) {
                        <div class="attachment" [class.is-image]="workspaceService.imageFiles[file.extension]">
                          @if (workspaceService.imageFiles[file.extension]) {
                            <div *inView>
                              <img [src]="communityService.buildFileUrl(file.user_id, file)" (click)="showImage(communityService.buildFileUrl(file.user_id, file))" class="image-border" alt="" />
                              <div class="p-x-5">
                                <span class="t-12 font-weight-bold">{{ file.filename }}</span>
                              </div>
                            </div>
                          }
                          @if (workspaceService.audioFiles[file.extension]) {
                            @if (communityService.displayAudioWaveforms) {
                              <div class="m-t-20">
                                @if (reply.shouldLoadWaveform) {
                                  <myp-waveform-comments
                                    (audioPlayed)="audioPlayed($event)"
                                    (audioPaused)="audioPaused($event)"
                                    [showComments]="false"
                                    #waveformComments
                                    [isPostAttachment]="true"
                                    [file]="file"
                                  ></myp-waveform-comments>
                                }
                                @if (!reply.shouldLoadWaveform) {
                                  <div style="height: 150px; background-color: rgba(0, 0, 0, 0.6)" class="d-flex align-items-center justify-content-center">
                                    <div class="text-center">
                                      <a class="btn btn-primary" (click)="reply.shouldLoadWaveform = true">Load Waveform</a>
                                      <br />
                                      <span>{{ file.filesize | bytesToSize }}</span>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                            @if (!communityService.displayAudioWaveforms) {
                              <div
                                class="post-audio-play"
                                [class.pulse-blue]="communityService.playingAudioFile && communityService.playingAudioFile.id == file.id"
                                (click)="playAudio(file, reply.id, $event)"
                              >
                                <fa-icon
                                  tabindex="0"
                                  (keyup.enter)="playAudio(file, reply.id, $event)"
                                  [icon]="communityService.playingAudioFile && communityService.playingAudioFile.id == file.id ? 'stop-circle' : 'play-circle'"
                                  class="t-40"
                                ></fa-icon>
                                <div class="d-flex m-l-10 align-items-center">
                                  <div>
                                    <span class="t-20 bold d-block">{{ file.filename }}</span>
                                    <span class="text-muted t-16">{{ file.filesize | bytesToSize }}</span>
                                  </div>
                                </div>
                              </div>
                            }
                          }
                          @if (workspaceService.videoFiles[file.extension]) {
                            <div *inView>
                              <video width="100%" [src]="file.url" controls></video>
                            </div>
                          }
                          @if (!workspaceService.imageFiles[file.extension] && !workspaceService.audioFiles[file.extension] && !workspaceService.videoFiles[file.extension]) {
                            <div>
                              <div class="generic-file-attachment">
                                {{ file.filename }}
                                <fa-icon icon="download" tabindex="0" (keyup.enter)="downloadFile(file)" (click)="downloadFile(file)"></fa-icon>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (reply.articles && reply.articles.length && !queued) {
                    <ul class="post-attachments pl-0" role="group" aria-label="articles">
                      @for (item of reply.articles; track item) {
                        <li style="list-style-type: none">
                          <button type="button" class="comment-article-attachment bg-transparent" (click)="showArticle(item)">
                            <fa-icon icon="newspaper" class="icon" aria-hidden="true"></fa-icon>
                            <div class="d-flex flex-column text-left">
                              <fui-heading [text]="item.article.name" [level]="4" fontSize="f7" extraClasses="bold"></fui-heading>
                              <span class="t-12 text-muted" aria-label="article created at">{{ item.article.created_at_pretty }}</span>
                              <span class="link bold text-right">
                                Read Article
                                <fa-icon icon="chevron-right" aria-hidden="true"></fa-icon>
                              </span>
                            </div>
                          </button>
                        </li>
                      }
                    </ul>
                  }
                  @if (reply.public_file_links && reply.public_file_links.length && !queued) {
                    <ul class="post-attachments pl-0" role="group" aria-label="links">
                      @for (item of reply.public_file_links; track item) {
                        <li style="list-style-type: none">
                          <button type="button" class="comment-article-attachment bg-transparent" (click)="goToPublicFile(item)">
                            <fa-icon [icon]="workspaceService.audioFiles[item.publicFile.extension] ? 'play-circle' : 'file'" class="icon" aria-hidden="true"></fa-icon>
                            <div class="d-flex flex-column text-left">
                              <fui-heading [text]="item.publicFile.filename" [level]="4" fontSize="f7" extraClasses="bold"></fui-heading>
                              <span class="t-12 text-muted" aria-label="file description">{{ item.publicFile.description }}</span>
                              <span class="link bold text-right">
                                View & Comment
                                <fa-icon icon="chevron-right" aria-hidden="true"></fa-icon>
                              </span>
                            </div>
                          </button>
                        </li>
                      }
                    </ul>
                  }
                  @if (reply.learn_content && reply.learn_content.length && !queued) {
                    <div class="post-attachments m-y-20 grid-container pad-10">
                      @for (item of reply.learn_content; track item) {
                        @if (item.content.type == "video") {
                          <myp-video-grid-item [video]="item.content"></myp-video-grid-item>
                        }
                        @if (item.content.type == "course" || item.content.type == "lesson") {
                          <myp-learn-list-item [item]="item.content"></myp-learn-list-item>
                        }
                      }
                    </div>
                  }
                  @if (reply.embeds && reply.embeds.length && !queued) {
                    <div class="post-attachments m-y-20 grid-container pad-10">
                      @for (embed of reply.embeds; track embed) {
                        <div class="message-embed message-embed--{{ embed.type }} message-embed--{{ embed.subtype }}">
                          <iframe width="560" height="315" [src]="embed.src" frameborder="0" allowfullscreen></iframe>
                        </div>
                      }
                    </div>
                  }
                  <div class="timestamp">
                    <ul class="list-inline mb-0">
                      <!-- <li class="list-inline-item">
                      <span class="sr-only">posted on</span>
                      {{ reply.created.toDate() | date: "MMM Do [at] h:mma" }}
                    </li> -->
                      @if (!communityService.profile || !communityService.profile.status || communityService.profile.status == "active") {
                        @if (reply.edited) {
                          <li class="list-inline-item">
                            <span class="edited-message">{{ "com.edited" | translate }}</span>
                          </li>
                        }
                        <li class="list-inline-item">
                          <button
                            type="button"
                            class="btn btn-transparent p-1"
                            (keyup.enter)="like(reply)"
                            (click)="like(reply)"
                            (focus)="likeBubbleMouseLeaveByFocus(0, 1)"
                            [attr.aria-pressed]="reply.iLike || (reply.likes && reply.likes.includes(this.userService.user?.id))"
                            aria-label="like"
                            [ngbTooltip]="'com.like_reply' | translate"
                            placement="right"
                          >
                            <fa-icon
                              class="msg-options-link"
                              [class.i-liked]="reply.iLike || (reply.likes && reply.likes.includes(this.userService.user?.id))"
                              icon="thumbs-up"
                              aria-hidden="true"
                            ></fa-icon>
                            <span class="sr-only">like</span>
                          </button>
                        </li>
                        @if (reply.likes && reply.likes.length) {
                          <li class="list-inline-item position-relative">
                            <div
                              class="like-count"
                              (click)="likeMouseEnter(reply)"
                              (keyup.enter)="likeMouseEnter(reply)"
                              (keyup.space)="likeMouseEnter(reply)"
                              (mouseenter)="likeMouseEnter(reply)"
                              (mouseleave)="likeMouseLeave(reply)"
                              role="button"
                              tabindex="0"
                              [attr.aria-expanded]="!!shouldShowLikesList"
                              aria-controls="like-bubble-container"
                            >
                              {{ reply.likes.length }}
                            </div>
                            <span class="sr-only">Number of likes {{ reply.likes.length }}</span>
                            @if (shouldShowLikesList == reply.id) {
                              <div class="like-bubble-container" id="like-bubble-container">
                                @if (activeHoveringLikeUserName) {
                                  <div style="position: absolute; top: -30px; background-color: rgba(0, 0, 0, 0.8); border-radius: 10px; padding: 10px">
                                    <span class="c-white">{{ activeHoveringLikeUserName }}</span>
                                  </div>
                                }
                                <ul class="like-bubble-background" (mouseenter)="likesContainerEnter(reply)" (mouseleave)="likesContainerLeave(reply)">
                                  @for (id of reply.likes; track id; let idx = $index) {
                                    <li
                                      (mouseenter)="likeBubbleMouseEnter(id)"
                                      (mouseleave)="likeBubbleMouseLeave(id)"
                                      (focus)="likeBubbleMouseEnter(id)"
                                      (focusout)="likeBubbleMouseLeaveByFocus(idx, reply.likes.length)"
                                      tabindex="0"
                                      (click)="viewProfile(id)"
                                      class="like-bubble"
                                      [ngStyle]="{
                                        'background-image':
                                          'url(' +
                                          (communityService.cachedPhotos[id] ? communityService.cachedPhotos[id] : 'https://s3.amazonaws.com/mypresonus/profile/' + id + '-profile-photo.png') +
                                          ')',
                                      }"
                                      role="link"
                                    >
                                      <span class="sr-only">go to {{ activeHoveringLikeUserNameList[id] ?? "user" }} profile</span>
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </li>
                        }
                        @if (!reviewing) {
                          <li class="list-inline-item">
                            <button
                              class="btn btn-transparent p-1"
                              [attr.aria-expanded]="comment.replying"
                              (keyup.enter)="toggleReplyUI(comment, reply, true)"
                              (click)="toggleReplyUI(comment, reply, true)"
                              aria-label="reply"
                              [attr.aria-controls]="comment.key + '_reply_input_container'"
                              [ngbTooltip]="'com.reply' | translate"
                              placement="right"
                            >
                              <fa-icon class="msg-options-link" icon="reply" aria-hidden="true"></fa-icon>
                              <span class="sr-only">reply</span>
                            </button>
                          </li>
                        }
                        <li class="list-inline-item">
                          <button
                            class="btn btn-transparent p-1"
                            (keyup.enter)="msgOptions(reply)"
                            (click)="msgOptions(reply)"
                            aria-label="options"
                            [ngbTooltip]="'sphere.options' | translate"
                            placement="right"
                          >
                            <fa-icon class="msg-options-link" icon="ellipsis-h" aria-hidden="true"></fa-icon>
                            <span class="sr-only">options</span>
                          </button>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          }
        }
      </ul>
    </div>
  }
  <!-- END | replies -->

  <!-- START | comment replying -->
  @if (comment.replying) {
    <div class="form-group m-b-0 w-full" id="comment-replying">
      <label id="reply-label" class="control-label reply-label">Reply</label>
      <div
        class="d-block reply-input"
        (onFileDrop)="droppedFile($event)"
        ng2FileDrop
        [uploader]="uploader"
        (fileOver)="fileOverBase($event)"
        [class.hovering]="hasBaseDropZoneOver && isCommunityPost"
        [class.w-full]="!isCommunityPost"
        [id]="comment.key + '_reply_input_container'"
      >
        <myp-message-input
          #replyInput
          (returnPressed)="sendReply($event, comment)"
          type="span"
          [mentionSource]="isCommunityPost && !betaStringId ? 'community_profiles' : false"
          [inputID]="comment.key + '_reply_input'"
          [useQuill]="betaStringId"
          [placeholder]="'com.ctrl_enter' | translate"
          [backgroundColor]="appService.activeTheme == 'dark' || forceDark ? '#2e2e2e' : '#e9e9e9'"
          [includeSendButton]="true"
          [shouldDetectContent]="!betaStringId"
          (valueChanged)="replyContentChanged($event)"
          ariaDescribedBy="instructions"
          ariaLabelBy="reply-label"
        ></myp-message-input>
      </div>
    </div>
    <div class="d-flex justify-content-between m-t-5">
      <div class="d-flex align-items-center">
        <span class="t-12" id="instructions">{{ "com.hit_ctrl_enter" | translate }}</span>
        @if (!betaStringId) {
          <div class="form-check form-check-inline">
            @if (isCommunityPost) {
              <input type="checkbox" id="pinpost" [(ngModel)]="pinReplyingToPost" class="m-l-10 m-r-5 pointer" />
            }
            @if (isCommunityPost) {
              <label for="pinpost" class="t-12 mb-0">Pin this post</label>
            }
          </div>
        }
      </div>
      @if (!uploadedAttachment && !uploadingFile && isCommunityPost) {
        <div class="d-flex align-items-center">
          <span class="m-r-10 t-12 bold">Attach:</span>
          <ul class="list-inline mb-0">
            <li class="list-inline-item">
              <button type="button" class="btn btn-transparent p-0" (click)="attachFile()" [ngbTooltip]="'File'" aria-label="file">
                <fa-icon class="circle-icon-btn" icon="file" aria-hidden="true"></fa-icon>
                <span class="sr-only">file</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button type="button" class="btn btn-transparent p-0" (click)="showAttach('videos')" [ngbTooltip]="'Video'" aria-label="video">
                <fa-icon class="circle-icon-btn" icon="video" aria-hidden="true"></fa-icon>
                <span class="sr-only">video</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button type="button" class="btn btn-transparent p-0" (click)="showAttach('articles')" [ngbTooltip]="'Article'" aria-label="article">
                <fa-icon class="circle-icon-btn" icon="newspaper" aria-hidden="true"></fa-icon>
                <span class="sr-only">article</span>
              </button>
            </li>
          </ul>
        </div>
      }
      <!-- <a class="link t-12 bold" (click)="attachFile()" *ngIf="!uploadedAttachment && !uploadingFile && isCommunityPost">Attach a File</a> -->
    </div>
  }
  <!-- END | comment replying -->

  @if (uploadingFiles && uploadingFiles.length && comment.replying) {
    <div>
      @for (file of uploadingFiles; track file) {
        <span class="text-muted t-14">{{ "general.uploading" | translate }}: {{ file.filename }} {{ file.progress }}%</span>
        <div class="post-progress-bar" [ngStyle]="{ width: (file.progress ? file.progress : 0) + '%' }"></div>
      }
    </div>
  }

  @if (replyInput && replyInput.selectedArticlesInMessage && replyInput.selectedArticlesInMessage.length) {
    <div>
      @for (item of replyInput.selectedArticlesInMessage; track item) {
        <div class="comment-article-attachment" (click)="showArticle(item)">
          <fa-icon icon="newspaper" class="icon"></fa-icon>
          <div>
            <span class="bold">{{ item.article.name }}</span>
            <br />
            <span class="t-12 text-muted">{{ item.article.created_at_pretty }}</span>
          </div>
          <fa-icon icon="times-circle" class="close-btn" (click)="removeArticle(item, $event)"></fa-icon>
        </div>
      }
    </div>
  }

  @if (replyInput && replyInput.selectedLearnContentInMessage && replyInput.selectedLearnContentInMessage.length) {
    <div class="m-y-20">
      @for (item of replyInput.selectedLearnContentInMessage; track item) {
        @if (item.content.type == "video") {
          <div class="grid-container wider pad-10">
            <myp-video-grid-item [showBorder]="true" [video]="item.content" [showRemoveFromPost]="true" (removeFromPostClicked)="removeLearnContent(item, $event)"></myp-video-grid-item>
          </div>
        }
        @if (item.content.type != "video") {
          <myp-learn-list-item
            [shouldShowButtons]="false"
            [showRemoveFromPost]="true"
            [item]="item.content"
            [preventNav]="true"
            (removeFromPostClicked)="removeLearnContent(item, $event)"
          ></myp-learn-list-item>
        }
      }
    </div>
  }

  @if (replyInput && replyInput.publicFileLinksInMessage && replyInput.publicFileLinksInMessage.length) {
    <div class="m-y-20">
      @for (item of replyInput.publicFileLinksInMessage; track item) {
        @for (item of replyInput.publicFileLinksInMessage; track item) {
          <div class="comment-article-attachment">
            <fa-icon [icon]="workspaceService.audioFiles[item.publicFile.extension] ? 'play-circle' : 'file'" class="icon"></fa-icon>
            <div>
              <span class="bold">{{ item.publicFile.filename }}</span>
              <br />
              <span class="t-12 text-muted">{{ item.publicFile.description }}</span>
            </div>
            <fa-icon icon="times-circle" class="close-btn" (click)="removePublicFile(item, $event)"></fa-icon>
          </div>
        }
      }
    </div>
  }

  @if (replyInput && replyInput.messageEmbeds && replyInput.messageEmbeds.length) {
    <div class="d-flex flex-column m-y-20">
      @for (embed of replyInput.messageEmbeds; track embed) {
        <div class="message-embed message-embed--{{ embed.type }} message-embed--{{ embed.subtype }}">
          <fa-icon icon="times-circle" class="close-btn" (click)="removeEmbed(embed, $event)"></fa-icon>
          <iframe width="560" height="315" [src]="embed.embedSrc" frameborder="0" allowfullscreen></iframe>
        </div>
      }
    </div>
  }

  @if (uploadedAttachments && uploadedAttachments.length && comment.replying) {
    <div class="d-flex flex-wrap">
      @for (attachment of uploadedAttachments; track attachment) {
        <div class="attachment replying-attachment">
          @if (workspaceService.imageFiles[attachment.extension]) {
            <img [src]="attachment.url" class="image-border" style="width: 200px" alt="" />
          }
          @if (workspaceService.audioFiles[attachment.extension]) {
            <audio id="audio_player" controls="true">
              <source [src]="attachment.url" type="audio/wav" />
            </audio>
          }
          @if (!workspaceService.audioFiles[attachment.extension] && !workspaceService.imageFiles[attachment.extension]) {
            <span class="gothic t-18">
              <fa-icon icon="file" class="m-r-10"></fa-icon>
              <span>{{ attachment.filename }}</span>
            </span>
          }
          <div class="remove" (click)="removeAttachment(attachment)"><fa-icon icon="times-circle" class="c-red"></fa-icon></div>
        </div>
      }
    </div>
  }

  <!-- START | Beta manager options -->
  @if (betaStringId && isBetaManager && !comment.pinned) {
    <div class="beta-manager-options">
      <hr />
      <div class="t-12 brandfont-black m-b-10">BETA MANAGER OPTIONS</div>
      <div class="d-flex flex-wrap beta-status-container">
        <div class="beta-status m-r-5 m-b-20">
          <span class="t-12 bold text-muted d-inline-block m-r-10 status-text">Type:</span>
          <br />
          <select class="form-control custom-select-sm" (ngModelChange)="selectBetaPostType($event)" [(ngModel)]="comment.beta_type">
            <option value="none">None</option>
            <option value="bug">Bug</option>
            <option value="feature_request">Feature Request</option>
            <option value="post">Post</option>
          </select>
        </div>
        <div class="beta-status m-l-5 m-b-20">
          <span class="t-12 bold text-muted d-inline-block m-r-10 status-text">Status:</span>
          <br />
          <select class="form-control custom-select-sm" (ngModelChange)="selectBetaPostStatus($event)" [(ngModel)]="comment.beta_status">
            <option value="none">None</option>
            <option value="open">Open</option>
            <option value="cannot_reproduce">Cannot Reproduce</option>
            <option value="fixed">Fixed</option>
            <option value="investigating">Investigating</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
      </div>
      <div>
        <div class="d-flex flex-wrap">
          <button class="brand-btn-reverse sm m-r-10" (click)="adminPinUnpinPost()" [attr.aria-label]="'Pin Post'">
            <fa-icon icon="thumbtack" class="m-r-5"></fa-icon>
            Pin Post
          </button>
          @if (!comment.beta_review_details?.reviewed_by) {
            <button class="brand-btn-reverse sm m-r-10" (click)="toggleMarkingAsReviewed()">Mark as Reviewed</button>
          }
          @if (comment.beta_review_details?.reviewed_by) {
            <button class="brand-btn-reverse sm m-r-10" (click)="toggleMarkingAsReviewed()">Edit Review</button>
          }
          @if (!comment.beta_review_details?.jira_ticket_number) {
            <button class="brand-btn-reverse sm" (click)="createJiraTicket()">Create Jira Ticket</button>
          }
        </div>
        @if (comment.beta_review_details?.reviewed_by) {
          <div class="m-t-10">
            <div>
              <fa-icon icon="check-circle" class="c-green m-r-10"></fa-icon>
              <span class="t-12 text-muted">Reviewed on {{ comment.beta_review_details.reviewed_on.toDate() | date }} by {{ comment.beta_review_details.reviewed_by?.name }}</span>
            </div>
            @if (comment.beta_review_details.review_text) {
              <div class="t-12">{{ comment.beta_review_details.review_text }}</div>
            }
            @if (comment.beta_review_details.jira_ticket_link) {
              <div>
                <a [href]="comment.beta_review_details.jira_ticket_link" class="t-12" target="_blank">Jira Ticket {{ comment.beta_review_details.jira_ticket_number }}</a>
              </div>
            }
          </div>
        }
      </div>
      @if (markingAsReviewed) {
        <div>
          <textarea class="form-control m-y-10" [(ngModel)]="betaReviewDetails.review_text" placeholder="Add any relevant notes here..."></textarea>
          <input class="form-control m-y-10 input-bg" [(ngModel)]="betaReviewDetails.jira_ticket_number" placeholder="Jira Ticket Number" />
          <input class="form-control m-y-10 input-bg" [(ngModel)]="betaReviewDetails.jira_ticket_link" placeholder="Jira Ticket Link" />
          <button class="btn btn-primary btn-sm" (click)="markAsReviewed()">Submit</button>
        </div>
      }
    </div>
  }
  @if (betaStringId && !isBetaManager && !comment.pinned) {
    <div>
      @if (comment.beta_type) {
        <div class="d-flex">
          <div style="width: 25px"><fa-icon [icon]="comment.beta_type == 'bug' ? 'bug' : 'question-circle'" [class.c-red]="comment.beta_type == 'bug'" class="m-r-10"></fa-icon></div>
          <span class="t-12 text-muted">Type: {{ comment.beta_type }}</span>
        </div>
      }
      @if (comment.beta_status) {
        <div class="d-flex">
          <div style="width: 25px"><fa-icon icon="info-circle" class="m-r-10"></fa-icon></div>
          <span class="t-12 text-muted">Status: {{ comment.beta_status }}</span>
        </div>
      }
      @if (comment.beta_review_details?.reviewed_by) {
        <div class="d-flex">
          <div style="width: 25px"><fa-icon icon="check-circle" class="c-green m-r-10"></fa-icon></div>
          <span class="t-12 text-muted">Reviewed on {{ comment.beta_review_details.reviewed_on.toDate() | date }} by {{ comment.beta_review_details.reviewed_by?.name }}</span>
        </div>
      }
      @if (comment.beta_review_details?.jira_ticket_number) {
        <div class="d-flex">
          <div style="width: 25px"><fa-icon icon="ticket" class="c-official-blue m-r-10"></fa-icon></div>
          <span class="t-12 text-muted">Jira Ticket Number: {{ comment.beta_review_details.jira_ticket_number }}</span>
        </div>
      }
    </div>
  }
  <!-- END | Beta manager options -->
</div>
